import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';

const popFade = keyframes`
  0% { transform: scale(0.5); opacity: 0; }
  40% { transform: scale(1.2); opacity: 1; }
  70% { transform: scale(1); opacity: 1; }
  100% { transform: scale(0.8); opacity: 0; }
`;

const NumberBox = styled(Box)`
  animation: ${popFade} 0.9s cubic-bezier(0.34, 1.56, 0.64, 1) forwards;
`;

const STEPS = ['3', '2', '1', 'SPIN!'];

interface CountdownOverlayProps {
  onDone?: () => void;
}

const CountdownOverlay: React.FC<CountdownOverlayProps> = ({ onDone }) => {
  const [step, setStep] = useState(0);

  useEffect(() => {
    if (step >= STEPS.length) {
      onDone?.();
      return;
    }
    const t = setTimeout(() => setStep(s => s + 1), 900);
    return () => clearTimeout(t);
  }, [step, onDone]);

  const current = STEPS[step];

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: 500,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'rgba(0,0,0,0.5)',
        pointerEvents: 'none',
      }}
    >
      {current && (
        <NumberBox key={step}>
          <Typography
            sx={{
              fontFamily: '"Comic Sans MS", cursive, sans-serif',
              fontWeight: 'bold',
              fontSize: step === STEPS.length - 1 ? '5rem' : '9rem',
              color: step === STEPS.length - 1 ? '#FFD700' : 'white',
              textShadow: '4px 4px 0 rgba(0,0,0,0.5)',
              userSelect: 'none',
            }}
          >
            {current}
          </Typography>
        </NumberBox>
      )}
    </Box>
  );
};

export default CountdownOverlay;
